/** @jsx jsx */

import { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import { renderToString } from 'react-dom/server';

export const Arc = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 415 242"
    preserveAspectRatio="xMidYMid slice"
    fill="none"
  >
    <g id="Swirl" clipPath="url(#clip0_872_990)">
      <path
        id="Vector"
        d="M0.000823975 242L414.826 242V0L0.000823975 0V242Z"
        fill={color}
      />
      <g id="Group" opacity="0.07">
        <path
          id="Vector_2"
          d="M414.459 146.45C354.837 113.389 282.334 94 204.137 94C128.707 94 58.5764 112.04 0.193359 142.99L0.193359 241.931L414.459 241.931L414.459 146.449L414.459 146.45Z"
          fill="black"
        >
          <animate
            attributeName="d"
            values="M414.459 146.45C354.837 113.389 282.334 94 204.137 94C128.707 94 58.5764 112.04 0.193359 142.99L0.193359 241.931L414.459 241.931L414.459 146.449L414.459 146.45Z;M437 141.311C370.796 106.447 290.289 78 203.459 78C119.702 78 41.8283 105.024 -23 137.662L-23 242L437 242L437 141.31L437 141.311Z;M414.459 146.45C354.837 113.389 282.334 94 204.137 94C128.707 94 58.5764 112.04 0.193359 142.99L0.193359 241.931L414.459 241.931L414.459 146.449L414.459 146.45Z"
            begin="0s"
            dur="8s"
            repeatCount="indefinite"
            fill="freeze"
            calcMode="linear"
            keyTimes="0;0.5;1"
          />
        </path>
        <path
          id="Vector_3"
          opacity="0.05"
          d="M414.764 146.617C414.663 146.561 414.561 146.505 414.459 146.449L414.764 146.617Z"
          fill="black"
        />
        <path
          id="Vector_4"
          opacity="0.05"
          d="M0 143.092L0.194 241.931V142.99C0.13 143.024 0.065 143.058 0 143.092Z"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_872_990">
        <rect width="415" height="242" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const arcSVGToString = color => renderToString(<Arc color={color} />);

// export const Arc = ({ color = '#66ccff' }) => {
//   return SVG({ color });
// };
